// src/api/api.js
import axios from 'axios';

const API_BASE_URL = 'https://api.bimari.org/api'; // Set your backend base URL here
// const API_BASE_URL = 'http://localhost:5000/api'; // Set your backend base URL here

// Create an Axios instance with default configuration0
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor for adding authentication token (if needed)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken'); // Check for token in localStorage
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`; // Add token to headers if it exists
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Function to handle API errors globally
const handleError = (error) => {
  if (error.response) {
    // The request was made, but the server responded with an error
    console.error('API error response:', error.response.data);
    return error.response.data;
  } else if (error.request) {
    // The request was made, but no response was received
    console.error('API error request:', error.request);
    return { error: 'No response from server' };
  } else {
    // Something went wrong in setting up the request
    console.error('API error message:', error.message);
    return { error: error.message };
  }
};

// Function for GET requests
const get = async (url, params) => {
  try {
    const response = await api.get(url, params);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// Function for POST requests
const post = async (url, data) => {
  try {
    const response = await api.post(url, data);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// Function for PUT requests
const put = async (url, data) => {
  try {
    const response = await api.put(url, data);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

// Function for DELETE requests
const del = async (url) => {
  try {
    const response = await api.delete(url);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export { get, post, put, del };
